<template>
  <layout-main-inner title="库存统计">
    <span slot="append">
      <el-radio-group slot="append"
                      style="margin-left: 10px;"
                      v-model="config.ownerRange"
                      @change="onTypeChange">
        <el-radio-button :label="1">企业维度</el-radio-button>
        <el-radio-button :label="0">客户维度</el-radio-button>
      </el-radio-group>

      <owner-select v-if="config.ownerRange === 0"
                    style="margin-left: 10px;"
                    v-model="config.ownerId" />
      <el-button type="primary"
                 style="margin-left: 10px;"
                 @click="onsearch">查询</el-button>
    </span>
    <el-row :gutter="20">
      <el-col :span="12">
        <layout-card-wrap hasHeaderSlot
                          v-loading="loading">
          <template slot="title">商品库存：{{inventorys.total}}</template>
          <template slot="form">
            <el-radio-group v-model="mode"
                            size="mini">
              <el-radio-button :label="1">饼图</el-radio-button>
              <el-radio-button :label="2">表格</el-radio-button>
            </el-radio-group>
          </template>
          <el-table border
                    v-if="mode=== 2"
                    height="200"
                    :data="inventorys.series">
            <el-table-column label="商品名称"
                             prop="name">
            </el-table-column>
            <el-table-column label="库存数量"
                             prop="value">
            </el-table-column>
          </el-table>
          <template v-else>
            <pie-chart v-if="inventorys.legend.length"
                       :opts="inventorys" />
            <empty v-else />
          </template>
        </layout-card-wrap>
      </el-col>
      <el-col :span="12">
        <layout-card-wrap hasHeaderSlot
                          v-loading="loading">
          <template slot="title">今日出库：{{inventoryinout1.total}}</template>
          <template slot="form">
            <el-radio-group v-model="mode1"
                            size="mini">
              <el-radio-button :label="1">饼图</el-radio-button>
              <el-radio-button :label="2">表格</el-radio-button>
            </el-radio-group>
          </template>
          <el-table border
                    v-if="mode1 === 2"
                    height="200"
                    :data="inventoryinout1.series">
            <el-table-column label="商品名称"
                             prop="name">
            </el-table-column>
            <el-table-column label="出库数量"
                             prop="value">
            </el-table-column>
          </el-table>
          <template v-else>
            <pie-chart v-if="inventoryinout1.legend.length"
                       :opts="inventoryinout1" />
            <empty v-else />
          </template>
        </layout-card-wrap>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            style="margin-top:15px">
      <el-col :span="12">
        <layout-card-wrap hasHeaderSlot
                          v-loading="loading">
          <template slot="title">本月出库：{{inventoryinout2.total}}</template>
          <template slot="form">
            <el-radio-group v-model="mode2"
                            size="mini">
              <el-radio-button :label="1">饼图</el-radio-button>
              <el-radio-button :label="2">表格</el-radio-button>
            </el-radio-group>
          </template>
          <el-table border
                    v-if="mode2 === 2"
                    height="200"
                    :data="inventoryinout2.series">
            <el-table-column label="商品名称"
                             prop="name">
            </el-table-column>
            <el-table-column label="出库数量"
                             prop="value">
            </el-table-column>
          </el-table>
          <template v-else>
            <pie-chart v-if="inventoryinout2.legend.length"
                       :opts="inventoryinout2" />
            <empty v-else />
          </template>
        </layout-card-wrap>
      </el-col>
      <el-col :span="12">
        <layout-card-wrap hasHeaderSlot
                          v-loading="loading">
          <template slot="title">本年出库：{{inventoryinout3.total}}</template>
          <template slot="form">
            <el-radio-group v-model="mode3"
                            size="mini">
              <el-radio-button :label="1">饼图</el-radio-button>
              <el-radio-button :label="2">表格</el-radio-button>
            </el-radio-group>
          </template>
          <el-table border
                    v-if="mode3 === 2"
                    height="200"
                    :data="inventoryinout3.series">
            <el-table-column label="商品名称"
                             prop="name">
            </el-table-column>
            <el-table-column label="出库数量"
                             prop="value">
            </el-table-column>
          </el-table>
          <template v-else>
            <pie-chart v-if="inventoryinout3.legend.length"
                       :opts="inventoryinout3" />
            <empty v-else />
          </template>
        </layout-card-wrap>
      </el-col>
    </el-row>
    <layout-card-wrap style="margin-top:15px"
                      hasHeaderSlot
                      v-loading="loading">
      <template slot="title">按周期统计</template>
      <template slot="form">
        <stock-form ref="stockform"
                    :callBack="getinventoryinouttrend" />
      </template>
      <!-- <summary-list :span="6"
                    :list="summaryRangeList" /> -->
      <el-card shadow="never"
               style="margin-top:15px">
        <e-charts :options="options"
                  :init-options="{}"
                  ref="charts"
                  autoresize />
      </el-card>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import StockForm from './busi/stock-form.vue'
import PieChart from './busi/pie-chart.vue'
// import SummaryList from './busi/summary.vue'
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import moment from 'moment'
import { mapState } from 'vuex'
import OwnerSelect from '../goods-storage/owner-select.vue'
// import clonedeep from 'lodash.clonedeep'
export default {
  name: 'stat-stock',
  components: { ECharts, StockForm, PieChart, OwnerSelect },
  data () {
    return {
      loading: false,
      config: { ownerRange: 1, ownerId: null }, //   ownerRange 1，查询企业仓库存；0，查询客户仓库存 查询某个进销商时 ownerId=设置值
      mode: 1,
      mode1: 1,
      mode2: 1,
      mode3: 1,
      inventorys: { total: 0, legend: [], series: [], selected: [] },
      inventoryinout1: { total: 0, legend: [], series: [], selected: [] },
      inventoryinout2: { total: 0, legend: [], series: [], selected: [] },
      inventoryinout3: { total: 0, legend: [], series: [], selected: [] },
      options: {
        title: {
          text: '平均库存/退货/出库数量折线图',
          textStyle: { fontSize: 16 }
        },
        tooltip: { trigger: 'axis' },
        grid: { left: 60, top: 60, right: 60, bottom: 60 },
        legend: {
          data: ['平均库存', '出库', '退货'],
          top: 'bottom'
        },
        xAxis: { type: 'category', data: [] },
        yAxis: {
          type: 'value',
          axisLabel: { formatter: '{value}' }
        },
        series: [
          { name: '平均库存', data: [], type: 'line' },
          { name: '出库', data: [], type: 'line' },
          { name: '退货', data: [], type: 'line' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  mounted () {
    this.getinventorys()
    this.suminventoryinout()
  },
  methods: {
    onsearch () {
      this.getinventorys()
      this.suminventoryinout()
      this.$refs.stockform.fetch()
    },
    onTypeChange (v) {
      console.log(v)
      if (v === 1) {
        this.config.ownerId = null
      }
      this.getinventorys()
      this.suminventoryinout()
      this.$refs.stockform.fetch()
    },
    getinventorys () {
      this.loading = true
      this.$store.dispatch('stat/getinventorys', {
        payload: { ...this.config, pageSize: 10000 },
        success: (res) => {
          this.loading = false
          console.log(res)
          let legend = []
          let series = []
          let selected = {}
          const result = res.data.records.filter(i => (i.stockBalance + i.frozenQty) > 0)
          result.forEach((i, index) => {
            series.push({ productId: i.productId, 'name': i.productName, 'value': i.stockBalance + i.frozenQty })
            legend.push(i.productName)
            selected[i.productName] = index < 6
          })
          const listGroup = {}
          series.forEach(i => {
            const id = i.productId
            if (listGroup[id]) {
              const item = listGroup[id]
              item.value = item.value + i.value
            } else {
              listGroup[id] = { name: i.name, value: i.value }
            }
          })
          const seriesResult = []
          Object.keys(listGroup).forEach(key => {
            seriesResult.push(listGroup[key])
          })
          this.inventorys = { total: res.data.totalStockBalance, legend, series: seriesResult, selected }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    suminventoryinout () {
      this.loading = true
      this.$store.dispatch('stat/suminventoryinout', {
        payload: { ...this.config },
        success: (res) => {
          this.loading = false
          console.log(res)
          let legend = []
          let series = []
          let selected = {}
          res.data.todayOutSellSums.forEach((i, index) => {
            series.push({ 'name': i.productName, 'value': i.stockQuantity })
            legend.push(i.productName)
            selected[i.productName] = index < 6
          })
          this.inventoryinout1 = { total: res.data.todayTotalStockQuantity, legend, series, selected }
          let legend1 = []
          let series1 = []
          let selected1 = {}
          res.data.currentMonthOutSellSums.forEach((i, index) => {
            series1.push({ 'name': i.productName, 'value': i.stockQuantity })
            legend1.push(i.productName)
            selected1[i.productName] = index < 6
          })
          this.inventoryinout2 = { total: res.data.currentMonthTotalStockQuantity, legend: legend1, series: series1, selected: selected1 }
          let legend2 = []
          let series2 = []
          let selected2 = {}
          res.data.currentYearOutSellSums.forEach((i, index) => {
            series2.push({ 'name': i.productName, 'value': i.stockQuantity })
            legend2.push(i.productName)
            selected2[i.productName] = index < 6
          })
          this.inventoryinout3 = { total: res.data.currentYearTotalStockQuantity, legend: legend2, series: series2, selected: selected2 }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getinventoryinouttrend (payload) {
      this.loading = true
      this.$store.dispatch('stat/getinventoryinouttrend', {
        payload: { ...payload, ...this.config },
        success: (res) => {
          this.loading = false
          console.log(res)
          let xAxisData = res.data.inventoryInoutStats.map(o => {
            if (payload.timeUnit === 'D') {
              return moment(o.statTime, 'YYYYMMDD').format('YYYY/MM/DD')
            } else if (payload.timeUnit === 'M') {
              return moment(o.statTime, 'YYYYMM').format('YYYY/MM')
            } else if (payload.timeUnit === 'Y') {
              return moment(o.statTime, 'YYYY').format('YYYY')
            }
          })
          let series1 = res.data.inventoryInoutStats.map(o => o.stockBalance)
          let series2 = res.data.inventoryInoutStats.map(o => o.outSellCount)
          let series3 = res.data.inventoryInoutStats.map(o => o.inReturnCount)
          this.options.xAxis.data = xAxisData
          this.options.series[0].data = series1
          this.options.series[1].data = series2
          this.options.series[2].data = series3
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.title-total {
  color: #969799;
  font-size: 14px;
  line-height: 20px;
  align-self: flex-end;
}
</style>
